if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.mediaElements = new Map();
        this.initializeMediaElements(); // <-- Initialize immediately
        this.initializeEventListeners();
      }

      // Immediately map any existing media elements
      initializeMediaElements() {
        this.querySelectorAll('[data-media-id]').forEach(node => {
          this.mediaElements.set(node.dataset.mediaId, node);
        });
      }

      initializeEventListeners() {
        // Observe for dynamic additions too
        const observer = new MutationObserver((mutations) => {
          mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
              if (node.nodeType === 1 && node.matches('[data-media-id]')) {
                this.mediaElements.set(node.dataset.mediaId, node);
              }
            });
          });
        });

        observer.observe(this, {
          childList: true,
          subtree: true
        });
      }

      hide() {
        super.hide();
        this.cleanupActiveStates();
      }

      show(opener) {
        super.show(opener);
        this.openedBy = opener;
        this.updateActiveMedia();
      }

      updateActiveMedia() {
        this.cleanupActiveStates();
        const activeMediaId = this.openedBy?.getAttribute('data-media-id');
        if (!activeMediaId) return;

        const activeMedia = this.mediaElements.get(activeMediaId);
        if (!activeMedia) return;

        this.activateMedia(activeMedia);
        this.centerMedia(activeMedia);
        this.handleDeferredMedia(activeMedia);
      }

      cleanupActiveStates() {
        this.querySelectorAll('[data-media-id].active').forEach(el => {
          el.classList.remove('active');
        });
      }

      activateMedia(mediaElement) {
        mediaElement.classList.add('active');
        this.updateRelatedMedia(mediaElement);
      }

      updateRelatedMedia(activeMedia) {
        const activeAltText = activeMedia.getAttribute('alt');
        if (!activeAltText) return;

        this.querySelectorAll(`[data-media-id][alt="${activeAltText}"]`).forEach(el => {
          el.classList.add('active');
        });
      }

      centerMedia(mediaElement) {
        const container = this.querySelector('[role="document"]');
        if (!container) return;

        const scrollLeft = (mediaElement.offsetLeft - (container.clientWidth / 2)) +
                         (mediaElement.offsetWidth / 2);
        container.scrollLeft = scrollLeft;
      }

      handleDeferredMedia(mediaElement) {
        if (
          mediaElement.nodeName === 'DEFERRED-MEDIA' &&
          mediaElement.querySelector('template') &&
          mediaElement.querySelector('.js-youtube')
        ) {
          mediaElement.loadContent();
        }
      }
    }
  );
}
